@if (active) {
  <div class="container">
    @if (open) {
      <nom-reporter-dialog
        [reports]="reports"
        [copyText]="copyText"
        (dismissOne)="removeReport($event)"
        (dismissAll)="dismissAll()"
        (copyAll)="copyAll()"
        (copyAllHistory)="copyEverythingSinceForever()"
        (dismissCopy)="dismissCopy()"
        >
      </nom-reporter-dialog>
    }
    @if (count) {
      <button
        class="error-alert"
        [class.pulse]="pulse"
        (click)="toggle()"
        (animationend)="animationEnd($event)"
        >
        <div class="error-count">
          <span>{{count > 99 ? '99+' : count}}</span>
          <span class="bang"></span>
        </div>
      </button>
    }
  </div>
}
